"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compileMessage = void 0;
const PARAMS_ARG = 'params';
/** Returns code that evals to a function that takes a params argument if needed. */
function compileMessage(message) {
    if (typeof message === 'string') {
        return `()=>${JSON.stringify(message)}`;
    }
    const messageNodes = message;
    const compiledNodes = messageNodes.map((node) => compileNode(node));
    return `(${PARAMS_ARG})=>[${compiledNodes.join(',')}].join('')`;
}
exports.compileMessage = compileMessage;
/** Returns code that evals to a value (either a string literal or a function call). */
function compileNode(node) {
    if (typeof node === 'string') {
        return JSON.stringify(node);
    }
    const htmlTagNode = node;
    if (htmlTagNode.tag !== undefined) {
        if (htmlTagNode.attrs === undefined) {
            return JSON.stringify(`<${htmlTagNode.isClosing ? '/' : ''}${htmlTagNode.tag}>`);
        }
        else if (typeof htmlTagNode.attrs === 'string') {
            return JSON.stringify(`<${htmlTagNode.isClosing ? '/' : ''}${htmlTagNode.tag} ${htmlTagNode.attrs}>`);
        }
        const compiledAttrNodes = htmlTagNode.attrs.map((node) => compileNode(node));
        const compiledNodes = [JSON.stringify(`<${htmlTagNode.isClosing ? '/' : ''}${htmlTagNode.tag} `)].concat(compiledAttrNodes, [JSON.stringify('>')]);
        return `(()=>[${compiledNodes.join(',')}].join(''))()`;
    }
    const placeholderNode = node;
    return (`(()=>{if('${placeholderNode.identifier}' in ${PARAMS_ARG})return ${PARAMS_ARG}.${placeholderNode.identifier};` +
        `throw new Error('Missing parameter "${placeholderNode.identifier}"')})()`);
}
//# sourceMappingURL=message_compiler.js.map